import React from "react";
import LegalLayout from "../components/LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout title="Termini e Condizioni" subtitle="Regolamento e condizioni di partecipazione" lastUpdate="20 maggio 2026">
      <p>
        I presenti Termini e Condizioni (di seguito "Termini") regolano la partecipazione al torneo
        di fantacalcio <strong>Fanta Partenope</strong>, organizzato da{" "}
        <strong>ASD Fanta Partenope</strong> (di seguito "Organizzatore"), e l'utilizzo del sito{" "}
        <strong>fantapartenope.it</strong>.
      </p>

      <h2>1. Organizzatore</h2>
      <p>
        ASD Fanta Partenope, con sede in Via Vittorio Emanuele Terzo, Casalnuovo di Napoli (NA), 80013 — Italia.
        <br />Partita IVA: 10774701212 — Iscrizione CONI n. 31102317.
        <br />Legale rappresentante: Carlo De Caprio.
        <br />PEC: <a href="mailto:fantapartenope@pec.it">fantapartenope@pec.it</a>.
      </p>

      <h2>2. Accettazione dei Termini</h2>
      <p>
        L'iscrizione al torneo e/o l'utilizzo del sito implicano la piena e incondizionata
        accettazione dei presenti Termini. Chi non accetta è invitato a non procedere con
        l'iscrizione e a non utilizzare il sito.
      </p>

      <h2>3. Requisiti di partecipazione</h2>
      <ul>
        <li>Età minima: <strong>18 anni compiuti</strong> al momento dell'iscrizione.</li>
        <li>Capacità di agire ai sensi del Codice Civile italiano.</li>
        <li>Fornitura di dati veritieri, aggiornati e completi.</li>
        <li>Disponibilità di un account valido sull'app <em>Fantacalcio</em> / <em>Fantagazzetta</em>, utilizzata per la gestione tecnica del torneo.</li>
      </ul>

      <h2>4. Quota di iscrizione</h2>
      <p>
        La quota di iscrizione per la stagione 2026/2027 è di <strong>€60,00</strong> (sessanta/00),
        IVA inclusa ove applicabile. La quota costituisce esclusivamente una{" "}
        <strong>fee di partecipazione</strong> alla singola edizione del torneo e{" "}
        <strong>non attribuisce alla persona pagante alcuna qualifica associativa</strong> all'ASD
        organizzatrice.
      </p>
      <p>
        Il pagamento può avvenire mediante:
      </p>
      <ul>
        <li>Carta di credito/debito (Visa, Mastercard) tramite la piattaforma Stripe;</li>
        <li>Klarna o PayPal tramite la piattaforma Stripe;</li>
        <li>Bonifico bancario sull'IBAN indicato in fase di iscrizione (causale obbligatoria).</li>
      </ul>
      <p>
        L'iscrizione si perfeziona esclusivamente <strong>al ricevimento dell'importo</strong> da
        parte dell'Organizzatore.
      </p>

      <h2>5. Politica di rimborso</h2>
      <p>
        Salvo quanto previsto al successivo capoverso, <strong>non è previsto alcun rimborso</strong>{" "}
        della quota di iscrizione, neppure parziale, una volta perfezionato il pagamento. Tale
        previsione è espressamente accettata dall'iscritto, anche ai sensi e per gli effetti dell'art.
        59, comma 1 lett. n) del D.Lgs. 206/2005 (Codice del Consumo), trattandosi di servizio
        connesso ad attività ricreative.
      </p>
      <p>
        È previsto rimborso <strong>esclusivamente nel caso di mancata partenza del torneo</strong>{" "}
        per cause imputabili all'Organizzatore. In tal caso il rimborso sarà effettuato entro 30
        giorni con lo stesso metodo di pagamento utilizzato per l'iscrizione, al netto di eventuali
        commissioni dei circuiti di pagamento.
      </p>

      <h2>6. Diritto di recesso</h2>
      <p>
        Trattandosi di servizio connesso ad attività ricreative con data di esecuzione determinata
        (la stagione sportiva), si applica l'esclusione dal diritto di recesso prevista dall'art. 59,
        comma 1 lett. n), D.Lgs. 206/2005. L'utente prende atto e accetta tale esclusione al momento
        dell'iscrizione.
      </p>

      <h2>7. Regolamento del torneo</h2>
      <p>
        Il torneo Fanta Partenope si svolge secondo il regolamento ufficiale pubblicato
        sull'app/portale di gestione (Fantacalcio/Fantagazzetta) e secondo le ulteriori comunicazioni
        diffuse dall'Organizzatore tramite il sito e i canali ufficiali. Il regolamento può includere,
        a titolo esemplificativo:
      </p>
      <ul>
        <li>Calendario e scadenze di formazione/sostituzione rosa;</li>
        <li>Modalità di assegnazione dei voti (basate sulle pagelle della Gazzetta dello Sport);</li>
        <li>Modalità di calcolo della classifica principale e delle leghe collaterali (Autumn, Winter, Spring, Summer, Champions, Return);</li>
        <li>Criteri di assegnazione dei premi.</li>
      </ul>

      <h2>8. Comportamento dei partecipanti — Squalifica</h2>
      <p>
        L'iscritto si impegna a partecipare al torneo in modo leale e rispettoso, conformandosi al
        regolamento e alle indicazioni dell'Organizzatore. Costituiscono motivo di{" "}
        <strong>squalifica immediata</strong>, senza diritto ad alcun rimborso, in via meramente esemplificativa:
      </p>
      <ul>
        <li>Violazione del regolamento del torneo;</li>
        <li>Utilizzo di account multipli o falsi;</li>
        <li>Cessione o vendita della posizione a terzi;</li>
        <li>Comportamenti offensivi, discriminatori o lesivi verso altri partecipanti o l'Organizzatore;</li>
        <li>Manomissione o tentativo di manomissione di sistemi, voti, classifiche.</li>
      </ul>

      <h2>9. Premi</h2>
      <p>
        I premi vengono assegnati in base alla classifica finale del torneo e delle competizioni
        collaterali. I premi possono essere <strong>in denaro</strong> oppure <strong>in beni materiali</strong>{" "}
        (gadget, abbonamenti, esperienze) a discrezione dell'Organizzatore.
      </p>
      <p>
        I premi in denaro sono erogati esclusivamente mediante <strong>bonifico bancario</strong>{" "}
        sull'IBAN intestato al vincitore, entro 60 giorni dalla chiusura ufficiale del torneo,
        previa eventuale comunicazione dei dati anagrafici e fiscali necessari da parte del
        vincitore stesso.
      </p>
      <p>
        I premi in denaro sono soggetti alla normativa fiscale vigente. Ai sensi dell'art. 30 D.P.R.
        600/1973, sui premi corrisposti dall'Organizzatore in qualità di sostituto d'imposta sarà
        applicata la <strong>ritenuta d'acconto del 25%</strong>, nei casi e nelle misure previste
        dalla legge. L'importo lordo del premio sarà pertanto indicato comprensivo di tale eventuale
        ritenuta.
      </p>
      <p>
        Il vincitore è tenuto a fornire all'Organizzatore tutti i dati necessari (codice fiscale,
        IBAN, ecc.) entro 30 giorni dalla comunicazione di vincita. Il mancato riscontro entro tale
        termine comporta la decadenza dal diritto al premio.
      </p>

      <h2>10. Limitazione di responsabilità</h2>
      <p>
        L'Organizzatore non è responsabile per:
      </p>
      <ul>
        <li>Disservizi imputabili alle piattaforme di terze parti utilizzate per il torneo (Fantacalcio/Fantagazzetta, Stripe, fornitori di hosting);</li>
        <li>Errori di voto o pagella derivanti dalle fonti ufficiali esterne (Gazzetta dello Sport);</li>
        <li>Mancata partecipazione dovuta a problemi tecnici imputabili all'iscritto (connessione internet, dispositivi, ecc.);</li>
        <li>Eventi di forza maggiore (sospensione del campionato di Serie A, pandemie, scioperi, ecc.) che impediscano lo svolgimento regolare del torneo.</li>
      </ul>
      <p>
        In caso di sospensione definitiva del torneo per cause non imputabili all'Organizzatore, lo
        stesso potrà a propria discrezione: (i) rinviare il torneo, (ii) ricalcolare la classifica
        sulla base delle giornate disputate, (iii) procedere a rimborsi parziali al netto di costi
        organizzativi già sostenuti.
      </p>

      <h2>11. Proprietà intellettuale</h2>
      <p>
        Loghi, immagini, testi e contenuti del sito sono di proprietà dell'Organizzatore o utilizzati
        su licenza. È vietata la riproduzione, anche parziale, senza autorizzazione scritta.
      </p>

      <h2>12. Trattamento dei dati personali</h2>
      <p>
        I dati personali raccolti sono trattati nel rispetto del GDPR e secondo quanto indicato nella{" "}
        <a href="/privacy" className="text-fp-cyan hover:underline">Privacy Policy</a>, che costituisce parte integrante dei presenti Termini.
      </p>

      <h2>13. Modifiche ai Termini</h2>
      <p>
        L'Organizzatore si riserva il diritto di modificare i presenti Termini in qualsiasi momento.
        Le modifiche saranno comunicate sul sito e si applicheranno alle iscrizioni successive alla
        pubblicazione. Le iscrizioni già perfezionate sono regolate dai Termini vigenti al momento
        dell'iscrizione, salvo modifiche più favorevoli all'utente.
      </p>

      <h2>14. Legge applicabile e Foro competente</h2>
      <p>
        I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia non
        risolvibile in via amichevole, sarà competente <strong>in via esclusiva il Foro di Napoli</strong>,
        salvo quanto inderogabilmente previsto dal Codice del Consumo per il consumatore (in tal caso
        sarà competente il foro di residenza/domicilio del consumatore).
      </p>

      <h2>15. Contatti</h2>
      <p>
        Per qualsiasi richiesta relativa ai presenti Termini, è possibile scrivere a:{" "}
        <a href="mailto:fantapartenope@pec.it">fantapartenope@pec.it</a> oppure contattarci via
        WhatsApp al{" "}
        <a href="https://wa.me/393778100717" target="_blank" rel="noopener noreferrer">+39 377 8100717</a>.
      </p>

      <p className="mt-10 text-xs text-white/40 border-t border-white/10 pt-6">
        Ai sensi e per gli effetti degli articoli 1341 e 1342 del Codice Civile, l'utente, mediante
        spunta della casella di accettazione dei presenti Termini al momento dell'iscrizione, dichiara
        di aver letto, compreso e specificamente approvato le clausole di cui agli articoli 5 (Politica
        di rimborso), 6 (Esclusione del diritto di recesso), 8 (Squalifica), 9 (Premi), 10
        (Limitazione di responsabilità) e 14 (Foro competente).
      </p>
    </LegalLayout>
  );
}
